import {
  Box,
  Grid,
  Menu,
  Slide,
  AppBar,
  Hidden,
  Dialog,
  Avatar,
  Button,
  SvgIcon,
  Toolbar,
  MenuItem,
  IconButton,
  Typography,
  DialogContent,
  DialogActions,
} from "@mui/material";
import clsx from "clsx";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import { ACROSS_LOGO } from "../../../assets";
import { useNavigate } from "react-router-dom";
import { ExitToApp } from "@mui/icons-material";
import { Menu as MenuIcon } from "react-feather";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../../context/Auth";
import TypeWrapper from "../../../utils/TypeWrapper";
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_REDUX_STATE } from "../../../store/clearstore";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    background: "#fff",
    boxShadow: "0px 0px 53px rgba(0, 0, 0, 0.25)",
    [theme.breakpoints.down("md")]: {},
  },
  logo: {
    marginRight: theme.spacing(2),
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    "& + &": {
      marginLeft: theme.spacing(2),
    },
  },
  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  mainheader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",

    "& svg": {
      color: theme.palette.text.primary,
    },
    "& .leftBox": {
      width: "306px",
      [theme.breakpoints.down("md")]: {
        width: "200px",
      },
      [theme.breakpoints.down("xs")]: {
        width: "150px",
      },
      "& img": {
        width: "150px",
        [theme.breakpoints.down("xs")]: {
          width: "104px",
          paddingLeft: "0 !important",
        },
      },
    },
  },
  menuPaper: {
    backgroundColor: TypeWrapper.COLORS.HX_WHITE,
  },
}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Logout Func
  const [isLogout, setIsLogout] = useState(false);
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const userEmail = useSelector((state) => state?.auth?.email);

  // ****** Logout Func ******
  const onLogout = async () => {
    dispatch(CLEAR_REDUX_STATE.CLEAR_LOGIN_DETAILS());
    toast.success("Logout successful!");
    navigate("/");
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleUserClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleUserClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      elevation={0}
      color="inherit"
      className={clsx(classes.root, className)}
      style={{ boxShadow: "none", background: "transparent" }}
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <Hidden mdUp>
          <IconButton onClick={onMobileNavOpen} style={{ padding: "0px" }}>
            <SvgIcon>
              <MenuIcon
                style={{
                  color: TypeWrapper.COLORS.HAMBURGER,
                  fontSize: "25px",
                }}
              />
            </SvgIcon>
          </IconButton>
        </Hidden>
        &nbsp; &nbsp;
        <Box className={classes.mainheader}>
          <Grid item container alignItems="center">
            {/* ****** Logo Container ****** */}
            <Grid item lg={3} md={3} sm={4} xs={6}>
              <Box className="leftBox">
                <IconButton
                  style={{ borderRadius: "10px" }}
                  onClick={() => navigate("/admin-dashboard")}
                >
                  <img
                    alt="Logo"
                    src={ACROSS_LOGO}
                    style={{ width: 200, padding: 15 }}
                  />
                </IconButton>
              </Box>
            </Grid>

            {/* ****** Profile Container ****** */}
            <Grid
              item
              lg={9}
              md={9}
              sm={8}
              xs={6}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Box
                className="displayEnd"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Hidden mdDown>
                  <Box
                    mt={2}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mx={3}
                  >
                    <Typography
                      style={{
                        color: "black",
                        fontSize: 17,
                        marginBottom: -15,
                        fontWeight: "500",
                        fontFamily: '"Poppins", serif',
                      }}
                    >
                      {userEmail ? userEmail : "Admin"}
                    </Typography>
                    <IconButton
                      style={{
                        borderRadius: "10px",
                        cursor: "default",
                        textAlign: "left",
                      }}
                    >
                      <Typography
                        style={{
                          color: "black",
                          fontSize: 13,
                          fontFamily: '"Poppins", serif',
                        }}
                      >
                        Admin
                      </Typography>
                    </IconButton>
                  </Box>
                </Hidden>

                <Box
                  alignItems="center"
                  style={{ display: "flex", justifyContent: "flex-end" }} // Ensures content is aligned to the right
                >
                  <IconButton
                    style={{ borderRadius: "10px" }}
                    onClick={handleUserClick}
                  >
                    <img
                      alt=""
                      height={40}
                      src={require("../../../assets/images/Profile.png")}
                    />
                  </IconButton>
                </Box>

                {/* ****** Change & Logout PopUp Container ****** */}
                <Box ml={2} style={{ cursor: "pointer" }}>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleUserClose}
                    classes={{ paper: classes.menuPaper }}
                  >
                    {/* <MenuItem
                      style={{
                        color: TypeWrapper.COLORS.BLACK,
                        fontFamily: "'Poppins', sans-serif",
                        backgroundColor: TypeWrapper.COLORS.HX_WHITE,
                        flexDirection: "column",
                      }}
                      onClick={() => {
                        handleUserClose();
                      }}
                    >
                      <Typography
                        variant="body1"
                        style={{
                          marginRight: 10,
                          fontFamily: '"Poppins", serif',
                        }}
                      >
                        {userEmail ? userEmail : "Admin"}
                      </Typography>
                    </MenuItem> */}

                    <MenuItem
                      style={{
                        color: TypeWrapper.COLORS.BLACK,
                        fontFamily: "'Poppins', sans-serif",
                        backgroundColor: TypeWrapper.COLORS.HX_WHITE,
                      }}
                      onClick={() => {
                        handleUserClose();
                        // navigate("/admin-profile");
                      }}
                    >
                      <AccountCircleOutlinedIcon
                        style={{ width: 20, marginRight: 10 }}
                      />
                      Settings
                    </MenuItem>

                    <MenuItem
                      style={{
                        color: TypeWrapper.COLORS.BLACK,
                        fontFamily: "'Poppins', sans-serif",
                        backgroundColor: TypeWrapper.COLORS.HX_WHITE,
                      }}
                      onClick={() => {
                        handleUserClose();
                        setIsLogout(true);
                      }}
                    >
                      <ExitToApp style={{ width: 20, marginRight: 10 }} />
                      Logout
                    </MenuItem>
                  </Menu>

                  {/* ****** Profile Logout PopUp Container ****** */}
                  {isLogout && (
                    <Dialog
                      maxWidth="xs" // Use "xs" for smaller dialogs on mobile devices
                      fullWidth
                      className={classes.dailogOpen}
                      open={isLogout}
                      TransitionComponent={Transition}
                      keepMounted
                      onClose={(event, reason) => {
                        if (
                          reason === "backdropClick" ||
                          reason === "escapeKeyDown"
                        ) {
                          return;
                        }
                        setIsLogout(false);
                      }}
                      BackdropProps={{
                        style: { pointerEvents: "none" },
                      }}
                      sx={{
                        "& .MuiDialog-paper": {
                          margin: 1,
                          padding: 0,
                          borderRadius: "4px",
                          backgroundColor: TypeWrapper.COLORS.HX_WHITE,
                        },
                      }}
                    >
                      <Box className="newModalBorder">
                        <Box
                          sx={{
                            padding: 2,
                            backgroundColor: TypeWrapper.COLORS.HX_WHITE,
                          }}
                          className="mainbox1"
                        >
                          <DialogContent>
                            <Box
                              className={classes.dialougTitle}
                              align="center"
                              sx={{ marginBottom: 2 }}
                            >
                              <Typography
                                variant="h6" // Smaller variant for mobile
                                sx={{
                                  fontWeight: 600,
                                  marginBottom: 1,
                                  color: TypeWrapper.COLORS.BLACK,
                                  fontFamily: "'Poppins', sans-serif",
                                }}
                              >
                                Logout
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: 500,
                                  fontSize: "0.875rem",
                                  color: TypeWrapper.COLORS.BLACK,
                                  fontFamily: "'Poppins', sans-serif",
                                }}
                              >
                                Are you sure you want to logout?
                              </Typography>
                            </Box>
                          </DialogContent>
                          <DialogActions
                            sx={{
                              gap: 1,
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: { xs: "column", sm: "row" },
                            }}
                          >
                            <Button
                              type="submit"
                              variant="contained"
                              sx={{
                                fontWeight: 600,
                                borderRadius: 30,
                                padding: "8px 16px",
                                textTransform: "none",
                                width: { xs: "100%", sm: 120 },
                                color: TypeWrapper.COLORS.HX_WHITE,
                                fontFamily: "'Poppins', sans-serif",
                                backgroundColor: TypeWrapper.COLORS.BTN_THEME,
                              }}
                              onClick={() => onLogout()}
                            >
                              Confirm
                            </Button>
                            <Button
                              type="submit"
                              variant="contained"
                              sx={{
                                fontWeight: 600,
                                borderRadius: 30,
                                padding: "8px 16px",
                                textTransform: "none",
                                width: { xs: "100%", sm: 120 },
                                color: TypeWrapper.COLORS.BLACK,
                                fontFamily: "'Poppins', sans-serif",
                                backgroundColor: TypeWrapper.COLORS.HX_WHITE,
                              }}
                              onClick={() => setIsLogout(false)}
                            >
                              Cancel
                            </Button>
                          </DialogActions>
                        </Box>
                      </Box>
                    </Dialog>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
};
TopBar.defaultProps = {
  onMobileNavOpen: () => {},
};

export default TopBar;

export function TopBarData() {
  const classes = useStyles();
  const auth = useContext(AuthContext);

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="flex-end">
        <Hidden xsDown>
          <Box>
            <Typography variant="h5">My Heading</Typography>
            <Typography
              variant="body1"
              style={{ color: TypeWrapper.COLORS.SB_HEADING }}
            >
              example@gmail.com
            </Typography>
          </Box>
        </Hidden>
        &nbsp; &nbsp;
        <Avatar
          src={
            auth?.userData?.profilePic
              ? `${auth?.userData?.profilePic}`
              : "https://picsum.photos/533/357"
          }
          className={classes.avatar}
          // onClick={() => navigate("/admin-profile")}
        />
      </Box>
    </>
  );
}
